import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { text4 } from '@osmosis/tailwind-ui/styles/text';
import Image from 'next/image';
import React from 'react';
import { LoggedOutProductLibraryContainsItem } from '../../types/library';
import { toSentenceCase } from '../../lib/shared/string/capitalize';
import { replaceS3ToCloudfront } from '../../lib/util/url';

type L2Props = {
  l1Id: string;
  l2: LoggedOutProductLibraryContainsItem;
  onSelect: (selection: LoggedOutProductLibraryContainsItem) => void;
  isActive?: boolean;
};

/**
 * LibrarySidebarItemLoggedOut render.
 */
const LibrarySidebarItemLoggedOut = (props: L2Props) => {
  const { l1Id, onSelect, isActive, l2 } = props;
  const { name, displayName, icon, type } = l2;
  const l2Id = `${l1Id}-${l2.id}`;

  const makeSelection = (obj: LoggedOutProductLibraryContainsItem) => {
    obj.type === 'redirect' ? window.open(obj.link, '_blank') : onSelect(obj);
  };

  const iconUrl = replaceS3ToCloudfront(icon);

  return (
    <Box cn="p-1 mt-1 ml-8">
      {type === 'tile' ? (
        <P
          cn={`${text4} hover:text-primary-700 cursor-pointer`}
          data-testid="more-topics-coming-soon"
        >
          {toSentenceCase(displayName || name)}
        </P>
      ) : (
        <Box
          onClick={() => makeSelection(l2)}
          data-testid="library-sidebar-nav-l2-name"
          cn="decoration-none"
          id={l2Id}
        >
          <Flex
            key={name}
            cn={`items-center flex-nowrap px-2 cursor-pointer rounded-lg hover:text-primary-600 hover:bg-slate-200 ${
              isActive ? 'bg-slate-300 hover:bg-slate-300' : ''
            }`}
          >
            {iconUrl ? (
              <Image
                data-testid="library-sidebar-nav-l2-icon"
                width={25}
                height={25}
                alt="subcategory icon"
                src={iconUrl}
              />
            ) : null}
            <P cn="m-2 hover:text-blue-600">
              {toSentenceCase(displayName || name)}
            </P>
          </Flex>
        </Box>
      )}
    </Box>
  );
};

export default LibrarySidebarItemLoggedOut;
